import React from "react";
import { useSelector } from "react-redux";
import "./GlobalLoadingComponent.css";

export function GlobalLoadingComponent({ loading }) {
  const tenantStyles = useSelector((state) => state.commonState.tenantStyles);

  return <div className="loadingScreen">{tenantStyles?.spinner}</div>;
}
